import { useState } from 'react'
import { toApiError } from '@/api/errors'

/** Maps a 422's violations onto known fields; anything else becomes a form-level message. */
export function useFieldErrors<F extends string>(fields: readonly F[]) {
  const [errors, setErrors] = useState<Partial<Record<F, string>>>({})
  const [formError, setFormError] = useState<string | null>(null)
  const reset = () => {
    setErrors({})
    setFormError(null)
  }
  const apply = (e: unknown) => {
    const apiError = toApiError(e)
    const next: Partial<Record<F, string>> = {}
    for (const v of apiError.violations) {
      const field = v.field.replace(/\[\d+\]$/, '') as F
      if (fields.includes(field)) next[field] = v.message
    }
    setErrors(next)
    setFormError(Object.keys(next).length ? null : apiError.message)
  }
  return { errors, formError, reset, apply }
}
